export const GET_SALES_INVOICES = gql`
    query GetSalesInvoices {
        getSalesInvoices {
            id
            status
            createdAt
            partner {
                id
                displayName
            }
            merchant {
                id
                displayName
                merchantAccountNumber
            }
            invoiceNumber
        }
    }
`;
